import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TeComponent } from './common/te-component';
import { theme } from './common/theme';
import { styleMap } from 'lit/directives/style-map';
import './te-text';

import { TeContextMenu } from '.';

/**
 * Context Menu Item Component
 */
@customElement('te-context-menu-item')
export class TeContextMenuItem extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .te-context-menu-item {
        margin: 0;
        padding: 12px 16px;
        user-select: none;
      }

      .te-context-menu-item:hover {
        background: ${theme.colors.shade1};
        cursor: pointer;
        border-collapse: separate;
      }
    `,
  ];

  /** Color of item text */
  @property({ type: String }) textColor = theme.colors.text.toString();
  /** List item is disabled */
  @property({ type: Boolean }) disabled = false;
  /** Text value for item */
  @property({ type: String }) text = '';

  getItemStyle() {
    return {
      cursor: this.disabled ? 'default' : 'pointer',
      pointerEvents: this.disabled ? 'none' : 'default',
    };
  }

  onItemClick(e: Event) {
    const { parentNode } = this as Element;
    (parentNode?.parentElement as TeContextMenu).onMenuToggle(e, false);
    this.handleClick(e);
  }

  render() {
    return html`
      <div
        class="te-context-menu-item"
        @click=${this.onItemClick}
        @touchend=${this.onItemClick}
        style=${styleMap(this.getItemStyle())}
      >
        <te-text color=${this.disabled ? theme.colors.shade3.toString() : this.textColor}>
          ${this.text}
        </te-text>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-context-menu-item': TeContextMenuItem;
  }
}
